import belts from "../belts";
import { FormContent } from "./temps/formContent";

export function Forms11() {
    // Belt data for 12th Kup
    const beltData = belts.find(belt => belt.id === 11);
    if (!beltData) {
        return <div>Belt data not found.</div>;
    }
    const nextBelt = belts.find(belt => belt.id === 10);
    if (!nextBelt) {
        return <div>Next belt data not found.</div>;
    }
      const prevBelt = belts.find(belt => belt.id === 12);
        const nextFormLink = "/resources/info/forms/10";
        const prevFormLink = "/resources/info/forms/12";
    
        return (
            <FormContent 
                beltData={beltData} 
                nextBelt={nextBelt} 
                prevBelt={prevBelt} 
                nextFormLink={nextFormLink} 
                prevFormLink={prevFormLink} 
            />
        );
}
